import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  toggleTour,
  toggleFilter,
  setCarousel,
} from "../actions/settingActions";

import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import Tour from "reactour";

import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  help: {
    margin: "20px",
    maxWidth: "365px !important",
  },
});

class HelpTour extends Component {
  disableBody = (target) => {
    this.props.setCarousel("tour");
    disableBodyScroll(target);
  };

  enableBody = (target) => {
    enableBodyScroll(target);
    this.props.setCarousel("mills");
  };

  openFilter = () => {
    if (!this.props.filterOpen) {
      this.props.toggleFilter(true);
    }
  };

  closeFilter = () => {
    if (this.props.filterOpen) {
      this.props.toggleFilter(false);
    }
  };

  render() {
    const steps = [
      {
        selector: ".mill-carousel",
        content: "Anzeige aller Mühlen im aktuellen Kartenausschnitt.",
        action: this.closeFilter,
      },
      {
        selector: ".mill-item",
        content:
          "Mit einem Klick auf eine Mühle (bspw. auf das Bild oder den Namen) gelangt man zu einer spezifischen Mühlen-Ansicht, die weiterführende Informationen und Bilder über jene Mühle bereithält.",
        action: this.closeFilter,
      },
      {
        selector: ".mapShow",
        content:
          ' Über die Schaltfläche "in Karte anzeigen" wird automatisch die Karte aktualisiert und die ausgewählte Mühle im Zentrum angezeigt. Die Mühle wird zudem im Karussell farblich hervorgehoben.',
        action: this.closeFilter,
      },
      {
        selector: ".carousel-button",
        content:
          "Die Mühlen lassen sich mit den blauen Buttons rechts und links durchstöbern.",
        action: this.closeFilter,
      },
      {
        selector: ".filter-button",
        content:
          "Die Vielzahl an Mühlen im Kreisgebiet können gefiltert werden...",
        position: "bottom",
        action: this.closeFilter,
      },
      {
        selector: ".filter-div",
        content:
          "...nach Gemeinde, Antriebsart und ob das Gebäude vorhanden ist. Sämtliche Kombinationen sind möglich. ",
        action: this.openFilter,
      },
      {
        selector: ".webmap",
        content: "Anzeige der Mühlenstandorte in einer Karte.",
        action: this.closeFilter,
      },
      {
        selector: ".esri-zoom",
        content:
          "Es kann über die Schaltflächen (alternativ über das Mausrad) gezoomt werden.",
        action: this.closeFilter,
      },
      {
        selector: ".esri-locate",
        content: "Die eigene Position kann mittels GPS bestimmt werden.",
        action: this.closeFilter,
      },
      {
        selector: '[title="Legende anzeigen"]',
        content:
          "Anzeige der Legende und Zuordnung der Symbole zu der jeweiligen Antriebsart.",
        position: "bottom",
        action: this.closeFilter,
      },
      {
        selector: '[title="Hintergrundkarte wählen"]',
        content:
          "Es können verschiedene Hintergrundkarten, wie das Luftbild, ausgewählt werden.",
        action: this.closeFilter,
      },
      {
        selector: '[title="zeitlichen Filter einstellen"]',
        content:
          "Neben den vorher genannten Filtermöglichkeiten kann ein zeitlicher Filter angegeben werden. Es ist damit möglich die Enstehungsentwicklung der Mühlen grafisch nachzuvollziehen. Alle angegebenen Filter sind gleichzeitig wirksam.",
        action: this.closeFilter,
      },
      {
        selector: ".search-button",
        content:
          "Die Mühlen können zusätzlich zur Karte auch anhand des Namens gesucht werden.",
        position: "bottom",
        action: this.closeFilter,
      },
      {
        selector: ".history-button",
        content:
          "Verweis auf das Geschichtsportal mit weiteren historischen Daten und Karten zum Kreis Herford.",
        position: "bottom",
        action: this.closeFilter,
      },
      {
        selector: ".info-button",
        // content: "Informationen und Hilfestellungen zu der Anwendung.",
        content:
          "Hilfestellungen, Informationen und Links mit u.a. anschaulichen Medien.",
        position: "bottom",
        action: this.closeFilter,
      },
      {
        content:
          "Wir wünschen viel Freude beim Stöbern und Entdecken – Klicken Sie sich um!",
      },
    ];

    // ArcGIS API for JS Version 4.17 unterstützt noch Internet Explorer

    // const stepsIE = [
    //   {
    //     selector: ".mill-carousel",
    //     content: "Anzeige aller Mühlen.",
    //     action: this.closeFilter,
    //   },
    //   {
    //     selector: ".mill-item",
    //     content:
    //       "Mit einem Klick auf eine Mühle (bspw. auf das Bild oder den Namen) gelangt man zu einer spezifischen Mühlen-Ansicht, die weiterführende Informationen und Bilder über jene Mühle bereithält.",
    //     action: this.closeFilter,
    //   },
    //   {
    //     selector: ".carousel-button",
    //     content:
    //       "Die Mühlen lassen sich mit den blauen Buttons rechts und links durchstöbern.",
    //     action: this.closeFilter,
    //   },
    //   {
    //     selector: ".filter-button",
    //     content:
    //       "Die Vielzahl an Mühlen im Kreisgebiet können gefiltert werden...",
    //     position: "bottom",
    //     action: this.closeFilter,
    //   },
    //   {
    //     selector: ".filter-div",
    //     content:
    //       "...nach Gemeinde, Antriebsart und ob das Gebäude vorhanden ist. Sämtliche Kombinationen sind möglich. ",
    //     action: this.openFilter,
    //   },
    //   {
    //     selector: ".noMap",
    //     content:
    //       "Der Internet Explorer unterstützt leider nicht die Anzeige der Mühlenstandorte in einer Karte. Für diese Ansicht müssen Sie einen anderen Browser verwenden.",
    //     action: this.closeFilter,
    //   },
    //   {
    //     selector: '[title="Geschichtsportal öffnen"]',
    //     content:
    //       "Verweis auf das Geschichtsportal mit weiteren historischen Daten und Karten zum Kreis Herford.",
    //     position: "bottom",
    //     action: this.closeFilter,
    //   },
    //   {
    //     selector: ".info-button",
    //     content: "Informationen und Hilfestellungen zu der Anwendung.",
    //     position: "bottom",
    //     action: this.closeFilter,
    //   },
    // ];

    // const isEdge = window.navigator.userAgent.indexOf("Edge") !== -1;
    // const isIE =
    //   window.navigator.userAgent.indexOf("Trident") !== -1 && !isEdge;

    return (
      <Tour
        steps={steps}
        isOpen={this.props.open}
        onRequestClose={this.props.toggleTour}
        onAfterOpen={this.disableBody}
        onBeforeClose={this.enableBody}
        badgeContent={(curr, tot) => `${curr} von ${tot}`}
        className={this.props.classes.help}
        accentColor={"#00568E"}
        maskSpace={0}
        showNavigationNumber={false}
        startAt={0}
        update={this.props.filterOpen}
      />
    );
  }
}

HelpTour.propTypes = {
  toggleTour: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  filterOpen: PropTypes.bool.isRequired,
  setCarousel: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  open: state.settings.tour,
  filterOpen: state.settings.filter,
});

export default connect(mapStateToProps, {
  toggleTour,
  toggleFilter,
  setCarousel,
})(withStyles(styles, { withTheme: true })(HelpTour));
